import type { MouseEvent } from "react";

import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

export const CancelMapModal = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { onCancelRoute } = useSelector(getModalParams) as ModalParams<"CancelMap">;
  const translate = useTranslate();

  const cancelRoute = onCancelRoute ?? "/create";

  const handleYes = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    dispatch(deactivateModal());
    go(cancelRoute);
  };

  return (
    <>
      <ModalHeader title={translate("app.create.cancel.modal_title")} />
      <StyledModalText>{translate("app.create.cancel.title")}</StyledModalText>
      <UIButton onClick={handleYes} as="a" href={cancelRoute} error fullwidth>
        {translate("app.create.cancel.confirm")}
      </UIButton>
    </>
  );
};
